import { AppRoute as R } from 'common/routing/app-route';
import { ParametrizedAppRoute as PR } from 'common/routing/parametrized-app-route';
import { SubscribePageQueryParams, SubscriptionParams } from './route-params';

/* eslint-disable max-len, space-in-parens */
const index =                     new PR<SubscriptionParams>(     `/subscription/:type`);
const subscribe =                 new R<SubscribePageQueryParams>(`${index.path}`);
const billingNotice =             new R(                          `${index.path}/company/:companyId/billing-notice`);
const renewSubscription =         new R(                          `${index.path}/renew`);
const updateSubscription =        new R(                          `${index.path}/update`);
const manageCompanySubscription = new PR<SubscriptionParams>(     `${index.path}/manage`);
/* eslint-enable */

export const Urls = {
  index,
  subscribe,
  billingNotice,
  renewSubscription,
  updateSubscription,
  manageCompanySubscription,
};

